module.exports = __webpack_public_path__ + "img/google-maps-icon.0021aa51.png";